export default __webpack_public_path__ + "static/premagic-web-square-b2e2d79d646be6e56402ebefb43ba2db.png";